import "../App.css";
import "./SideBar.css";
import * as React from "react";
import { styled, useTheme, createTheme } from "@mui/material/styles";
import { Box, useMediaQuery } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Slide from "@mui/material/Slide";
// import mgmlogo from "../assets/images/logo.png";

import {
  Viewer3D,
  __resizeCanvas,
  __getMarginValues,
  __animateIsometric,
} from "./ViewerScene";

import { SidebarSlideMenu } from "./SideBarSlideList";
import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  DISTRICT_HIGHLIGHTS,
  NOMAD,
  DOLBY,
  TMOBILE,
} from "../scripts/core/constants";
import { InfoTabComponent, __closeInfoTab } from "./InfoTab";
import { ZoomButtonComponent } from "./ZoomButtons";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useOrientation } from "react-use";

import {
  resetAllMapPathSvg,
  handleMouseEnterPoupHiding,
  __getOffsetValues,
} from "../components/customEvents.js";
import ConfirmationMessage from "../components/ConfirmationMessage";

// import DlHse_RO_Aria_L1 from "../assets/images/maps/v7/base_map_level_1.webp";
// import DlHse_RO_Aria_L2 from "../assets/images/maps/v7/base_map_level_2.webp";


import DlHse_RO_Aria_L1 from "../assets/images/maps/v9/L1.webp";
import DlHse_RO_Aria_L2 from "../assets/images/maps/v9/L2.webp";
import cosmo_level_1 from "../assets/images/maps/v9/cosmo_level_1.webp";
import cosmo_level_2 from "../assets/images/maps/v9/cosmo_level_2.webp";
import cosmo_level_3 from "../assets/images/maps/v9/cosmo_level_3.webp";
import cosmo_level_4 from "../assets/images/maps/v9/cosmo_level_4.webp";


import { useStoreDollHouseMap } from "../store";
// import ScreenChange from "../screen-change";
import $ from "jquery";
import RouteForm from "./RouteForm";
import { shallow } from "zustand/shallow";
import SvgTurnRight from "./turnRight-svg";
import MenuIcon from "@mui/icons-material/Menu";
import SvgTurnRightDisabled from "./turnRight-disabled-svg";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import { Scene3D } from "./Scene3D";
// import DollhouseView from "../components/DollhouseView";
// import { IsometricOverlay } from "./isometricModal";
import { useOverlayModal } from "./overlayModal";
import Login from "../login";
import { HideDollHouseModal } from "../components/HotspotInfoModal";

// import {
//   useMobileOrientation, isSafari,
//   isBrowser, isMobile, deviceDetect,
//   isMobileOnly, isTablet, isDesktop
// } from 'react-device-detect';
let drawerWidth = 320;
let dollHouseIndex, setDollHouseIndex;
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    background:
      "transparent linear-gradient(122deg, #000000 0%, #262626 100%) 0% 0% no-repeat padding-box !important",
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      marginLeft: 0,

      [theme.breakpoints.down("md")]: {
        position: "absolute",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}px)`,
      },
    }),
    width: "100%",
    height: "100vh",
  })
);

const PopUpItem = styled(Paper)(({ theme }) => ({
  background:
    "transparent linear-gradient(152deg, #000000 0%, #222222 100%) 0% 0% no-repeat padding-box",
  ...theme.typography.body2,
  padding: theme.spacing(0.1),
  height: "auto",
  // maxHeight: '190px',
  // maxHeight: "224px",
  overflow: "auto",
  position: "absolute",
  zIndex: 15,
  // bottom: "10px",
  marginLeft: "2px",
  width: " 270px",
  borderRadius: 6,
  color: "#ffffff",
  [theme.breakpoints.down("md")]: {
    zIndex: 1201,
    width: "230px",
    margin: "0 15px !important",
    top: "65px",
    background: "#2F2F2F 0% 0% no-repeat padding-box",
    overflow: "hidden",
  },
}));

const ExitItem = styled(Paper)(({ theme }) => ({
  background: "transparent",
  position: "absolute",
  boxShadow: "none",
  zIndex: 20,
  right: "10px",
  top: "0",
  width: "127px",
  height: "57px",
  border: "none",
  borderRadius: 10,
  color: "#ffffff",
  [theme.breakpoints.down("md")]: {
    background: "#000 0% 0% no-repeat padding-box",
    height: "37px",
    display: "flex",
    flex: "content",
    justifyContent: "center",
    width: "84px",
    borderRadius: "4px",
    top: "4px",
    marginTop: "8px", 
  },
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background: "transparent",
  width: `60px`,
  boxShadow: "none",
  overflow: "hidden",
  left: 0,
  ...(open && {
    width: `0`,
    marginLeft: `${drawerWidth}px`,
    height: "100vh",
    [theme.breakpoints.down("md")]: {
      marginLeft: "260px",
    },
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  boxShadow: "none",
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

let barOpen, setbarOpen;
let Showexit, setShowexit;
let show, setShow;
let iconSwitch, setIconvSwitch;
let store;
let enableinfotab, setEnableinfotab;
let open, setOpen;
let _xs, _sm;

function switchdollhouse() {
  store.index = false;
  setDollHouseIndex(true);
}

function leftBarVisibility(e) {
  setbarOpen(e);
  updateWindowSize();
}
function exitVisibility(e) {
  setShowexit(e);
}

function _IntoTabClick() {
  setEnableinfotab(true);
  setShow(false);
  setIconvSwitch("");
  __mobileHideBar();
}

function __mobileHideBar() {
  if (_xs || _sm) {
    setOpen(false);
  }
}

function updateWindowSize() {
  //console.log("-----", open, _sm);
  if (open === true) {
    if (_xs || _sm) {
      // console.log("mobile");
      __resizeCanvas(window.innerWidth, window.innerHeight);
    } else {
      // console.log("not mobile");
      __resizeCanvas(window.innerWidth - drawerWidth, window.innerHeight);
    }
  }
  if (open === false) {
    __resizeCanvas(window.innerWidth, window.innerHeight);
  }
}

let PersistentDrawerLeft = () => {
  const theme = useTheme();
  const _customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1000,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  store = useOverlayModal();
  const [_mouseY, set_mouseY] = React.useState(0);
  _xs = useMediaQuery(_customTheme.breakpoints.only("xs"));
  _sm = useMediaQuery(_customTheme.breakpoints.only("sm"));
  // console.log(_sm, theme.breakpoints.only("sm"),
  //   _customTheme.breakpoints.only("sm"));
  // const _md = useMediaQuery(theme.breakpoints.only("md"));
  // const _lg = useMediaQuery(theme.breakpoints.only("lg"));
  // const _xl = useMediaQuery(theme.breakpoints.only("xl"));
  [open, setOpen] = React.useState(false);
  [show, setShow] = React.useState(false);
  const [sidebarname, setSidebarname] = React.useState("");
  [iconSwitch, setIconvSwitch] = React.useState("");
  [Showexit, setShowexit] = React.useState(false);
  const [marginMain, setmarginMain] = React.useState(320);
  const [highlightText, setHighlightText] = React.useState("");
  const [snackopen, setSnackopen] = React.useState(false);
  const [originValueKey, setoriginValueKey] = React.useState("");
  const [destinationValueKey, setdestinationValueKey] = React.useState("");
  [barOpen, setbarOpen] = React.useState(false);
  const [mapRenderDatas, setMapRenderData] = React.useState(null);
  const [mapAreaselection, setMapAreaSelection] = React.useState("");
  const [routePathType, setRoutePath] = React.useState("all");
  const [renderViewType, setRenderVIewType] = React.useState("ISOMETRIC_VIEW");
  [dollHouseIndex, setDollHouseIndex] = React.useState(false);
  const [sanckMessage, setsanckMessage] = React.useState("");
  const [confirmationVisibile, setconfirmationVisibile] = React.useState(false);
  const [
    confirmationMessagsPreviousContent,
    setconfirmationMessagsPreviousContent,
  ] = React.useState(null);
  const [useSubmitted, setUserSubmitted] = React.useState(false);
  const [levelMapReset, setLevelMapReset] = React.useState(false);
  const [busIcon, setBusIcon] = React.useState(false);
  const [allIcon, setAllIcon] = React.useState(false);
  const [walkIcon, setWalkIcon] = React.useState(false);
  const [tramIcon, setTramIcon] = React.useState(false);
  const [dollhouseImages, setDollhouseImages] = React.useState(null);
  [enableinfotab, setEnableinfotab] = React.useState(false);
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      updateMapAreaSelection: state.updateMapAreaSelection,
      changeDrawerStatus: state.changeDrawerStatus,
      resetDollhouseMap: state.resetDollhouseMap,
      removeSourcePoiSelected: state.removeSourcePoiSelected,
      removeDestinationPoiSelected: state.removeDestinationPoiSelected,
      setSourceAreaSelected: state.setSourceAreaSelected,
      setDestinationAreaSelected: state.setDestinationAreaSelected,
      sourceAreaSelected: state.sourceAreaSelected,
      destinationAreaSelected: state.destinationAreaSelected,
    }),
    shallow
  );
  const { type } = useOrientation();
  const [screenPotrait, setscreenPotrait] = React.useState(true);

  React.useEffect(() => {
    const imageUrls = [
      DlHse_RO_Aria_L1,
      DlHse_RO_Aria_L2,
      cosmo_level_1,
      cosmo_level_2,
      cosmo_level_3,
      cosmo_level_4,
    ];

    function loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (error) => reject(error);
        img.src = src;
      });
    }

    const loadedImages = [];

    Promise.all(imageUrls.map(loadImage))
      .then((images) => {
        loadedImages.push(...images);
        setDollhouseImages(loadedImages);
      })
      .catch((error) => {
        console.error("Error loading images:", error);
      });
  }, []);

  // React.useEffect(() => {
  //   const wWidth = $(window).width();
  //   const wHeight = $(window).height();
  //   if (wHeight > wWidth) {
  //     setscreenPotrait(false);
  //   } else {
  //     setscreenPotrait(true);
  //   }
  // }, [type]);

  React.useEffect(() => {
    if (_xs || _sm) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [_xs, _sm]);

  const __routeIconHighlight = (all, bus, walk, tram) => {
    setAllIcon(all);
    setBusIcon(bus);
    setWalkIcon(walk);
    setTramIcon(tram);
  };
  const __snackClose = () => {
    setSnackopen(false);
  };

  const handleDrawerOpen = () => {
    if (_xs || _sm) {
      if (enableinfotab) __closeInfoTab();
    }
    setOpen(true);
    store.offset = 320;
    __getMarginValues(drawerWidth);
    __getOffsetValues(drawerWidth);
    if (_xs || _sm) {
      setmarginMain(0);
      __resizeCanvas(window.innerWidth, window.innerHeight);
    } else {
      __resizeCanvas(window.innerWidth - drawerWidth, window.innerHeight);
      setmarginMain(drawerWidth);
    }

    dollhouseStore.changeDrawerStatus(true);
    $(".react-transform-component").removeClass(
      "react-transform-component-dd "
    );
  };

  const handleDrawerClose = () => {
    store.offset = 0;
    setOpen(false);
    setShow(false);
    setIconvSwitch("");
    __resizeCanvas(window.innerWidth, window.innerHeight);
    __getMarginValues(0);
    __getOffsetValues(0);
    setmarginMain(0);
    dollhouseStore.changeDrawerStatus(false);
    $(".react-transform-component").addClass("react-transform-component-dd ");
  };

  const setPopupName = (text) => {
    setSidebarname(text);
  };

  const changeMainRenderViewToDollHouse = (area) => {
    // console.log(area);
    if (area === "Aria" || area === "Aria1") area = "ARIA";

    setRenderVIewType("DOLLHOUSE_VIEW");
    setMapAreaSelection(area);
  };

  const exploreBuildingView = (name) => {
    store.index = false;
    setDollHouseIndex(true);
    if (name === "Building_1_L_a") {
      name = PARK_MGM;
    }
    if (name === "Vdara_Towers") {
      name = VDARA;
    }
    if (name === "Cosmopolitan_Build_2") {
      name = THE_COSMOPOLITAN;
    }
    if (name === "Cosmopolitan_Build_1") {
      name = THE_COSMOPOLITAN;
    }
    if (name === "Cosmopolitan_Build_2") {
      name = BELLAGIO;
    }
    __exploreClick(name);
    exitVisibility(true);
    changeMainRenderViewToDollHouse(name);
    dollhouseStore.updateMapAreaSelection(name);
  };

  const handleRouteFormDollhousemapselection = (name) => {
    exitVisibility(true);
    changeMainRenderViewToDollHouse(name);
    dollhouseStore.updateMapAreaSelection(name);
  };

  const __exploreClick = (text) => {
    // console.log('name', text)
    if (text === TMOBILE || text === DOLBY) return;
    setShow(true);
    setPopupName(text);
    setIconvSwitch(text);
  };

  const sidemenuListNameClickEvent = (val) => {
    // console.log('sidebar');
    HideDollHouseModal();
    if (enableinfotab) __closeInfoTab();
    setEnableinfotab(true);
    setShow(false);
    setIconvSwitch("");
    store.index = false;
    setDollHouseIndex(true);
    changeMainRenderViewToDollHouse(val);
    dollhouseStore.updateMapAreaSelection(val);

    setHighlightText(val);
    if (!Showexit) {
      setShowexit(true);
    }

    if (_xs || _sm) {
      handleDrawerClose();
    }
  };

  const removeConfirmationMessage = () => {
    setconfirmationVisibile(false);
  };

  const exitApplicaitonMap = () => {
    store.open = false;
    HideDollHouseModal();
    setDollHouseIndex(false);
    setoriginValueKey("");
    setdestinationValueKey("");
    resetAllMapPathSvg();
    setShow(false);
    setIconvSwitch("");
    setPopupName("");
    changeMainRenderViewToDollHouse(null);
    setShowexit(true);
    setconfirmationMessagsPreviousContent(null);
    setconfirmationVisibile(false);
    setUserSubmitted(false);
    exitVisibility(false);
    setRenderVIewType("ISOMETRIC_VIEW");
    setMapRenderData(null);
    setMapAreaSelection("");
    setLevelMapReset(true);
    dollhouseStore.resetDollhouseMap();
    setHighlightText("");
    if (_xs || _sm) {
      setOpen(false);
    }
  };

  const agreeConfirmation = () => {
    if (confirmationMessagsPreviousContent !== null) {
      setoriginValueKey("");
      setdestinationValueKey("");
      setShow(false);
      setIconvSwitch("");
      setPopupName("");
      changeMainRenderViewToDollHouse(null);
      setShowexit(true);
      setconfirmationMessagsPreviousContent(null);
      setconfirmationVisibile(false);
      setUserSubmitted(false);
      setLevelMapReset(true);
      dollhouseStore.resetDollhouseMap();
      resetAllMapPathSvg();
    }
  };

  const disagreeConfirmation = () => {
    setconfirmationVisibile(false);
  };

  window.addEventListener("resize", () => {
    // const wWidth = $(window).width();
    // const wHeight = $(window).height();
    // if (wHeight > wWidth) {
    //   // setLandscape(false);
    //   // alert('potrait')
    //   setscreenPotrait(false);
    // } else {
    //   // alert('landscape')
    //   setscreenPotrait(true);
    //   // setLandscape(true);
    // }
    updateWindowSize();
  });

  const handleAriaRouteSelection = (text) => {
    if (dollhouseStore.sourceAreaSelected === text) {
      setsanckMessage("first area and second area route cannot be same!!!.");
      setSnackopen(true);
      return;
    }

    if (dollhouseStore.sourceAreaSelected === "") {
      dollhouseStore.setSourceAreaSelected(text);
    } else {
      dollhouseStore.setDestinationAreaSelected(text);
    }
  };

  const drawListToggle = (val, e) => {
    // console.log(e.clientY)
    set_mouseY(e.clientY);
    if (enableinfotab) __closeInfoTab();
    if (val === iconSwitch) {
      setShow(false);
      setIconvSwitch("");
      dollhouseStore.updateMapAreaSelection(null);
      setHighlightText("");
    } else {
      setShow(true);
      setIconvSwitch(val);
      setPopupName(val);
      // console.log(val, '-1111111111')
      dollhouseStore.updateMapAreaSelection(val);
      setHighlightText(val);
      changeMainRenderViewToDollHouse(val);
    }

    if (!Showexit) {
      setShowexit(true);
    }
  };

  const handleMouseEnter = () => {
    handleMouseEnterPoupHiding();
  };

  return (
    <>
      {/* {(type === "portrait-primary" ||
        type === "portrait" ||
        !screenPotrait) && (
       <>
         <ScreenChange></ScreenChange>
       </>
      )} */}

      <Box
        sx={{
          display: "flex",
          opacity: screenPotrait ? 1 : 0,
        }}
      >
        {barOpen && (
          <Box
            id="app-parent"
            sx={{ opacity: screenPotrait ? 1 : 0 }}
            onMouseEnter={handleMouseEnter}
          >
            <CssBaseline />

            <AppBar id="appHeader" position="fixed" open={open}>
              <Toolbar sx={{ display: open ? "none" : "block" }}>
                <IconButton
                  id="openDrawer"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  sx={{
                    mr: 2,
                    background: "#000000",
                    padding: "2px",
                    border: "solid 1.4px",
                    top: "8px",
                    height: "35px",
                    width: "35px",
                    color: "#FFFFFF",
                    ...(open && { display: "none" }),
                    "&:hover": {
                      backgroundColor: "#b59442",
                    },
                  }}
                >
                  <MenuIcon
                    sx={{
                      color: "##FFFFFF",
                      display: "none",
                      [_customTheme.breakpoints.down("md")]: {
                        display: "block",
                      },
                    }}
                  />
                  <KeyboardDoubleArrowRightIcon
                    sx={{
                      color: "##FFFFFF",
                      display: "block",
                      [_customTheme.breakpoints.down("md")]: {
                        display: "none",
                      },
                    }}
                  />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Drawer
              sx={{
                [_customTheme.breakpoints.up("md")]: {
                  "& ::-webkit-scrollbar": {
                    width: "0.2em",
                  },

                  "& ::-webkit-scrollbar-track": {
                    webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
                  },

                  "& ::-webkit-scrollbar-thumb": {
                    backgroundColor: "#bda770",
                    outline: "1px solid slategrey",
                  },
                },
                [_customTheme.breakpoints.down("md")]: {
                  width: "100%",
                },
                border: "none",
                width: "320px",
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                  width: "320px",
                  border: "none",
                  background:
                    "transparent linear-gradient(179deg, #000000 0%, #292929 100%) 0% 0% no-repeat padding-box",
                  boxSizing: "border-box",
                  height: "100vh",
                  overflowX: "hidden",
                  [_customTheme.breakpoints.down("md")]: {
                    width: "530px",
                    backgroundSize: "260px 100%",
                    overflow: "hidden",
                    height: "100% !important",
                  },
                },
              }}
              variant="persistent"
              anchor="left"
              open={open}
            >
              <DrawerHeader
                sx={{
                  flexDirection: "row-reverse",
                }}
              >
                <Box
                  component="img"
                  sx={{
                    maxWidth: 180,
                    padding: "0px 12px",
                  }}
                  alt="MGM RESORTS"
                  src={'/MGM/3.png'}
                />
                <IconButton
                  id="closeDrawer"
                  onClick={handleDrawerClose}
                  sx={{
                    background: "#000000",
                    color: "#FFFFFF",
                    position: "fixed",
                    left: "300px",
                    height: "35px",
                    width: "35px",
                    top: "8px",
                    border: "solid 1.4px",
                    padding: "2px",
                    "&:hover": {
                      backgroundColor: "#b59442",
                    },
                    [_customTheme.breakpoints.down("md")]: {
                      left: "530px",
                      top: "15px",
                      border: "none",
                      background: "transparent",
                    },
                  }}
                >
                  <CloseIcon
                    id="drawer-close"
                    sx={{
                      color: "##FFFFFF",
                      display: "none",
                      [_customTheme.breakpoints.down("md")]: {
                        width: "1.5em",
                        height: "1.5em",
                        display: "block",
                      },
                    }}
                  />
                  <KeyboardDoubleArrowLeftIcon
                    sx={{
                      color: "##FFFFFF",
                      display: "block",
                      [_customTheme.breakpoints.down("md")]: {
                        display: "none",
                      },
                    }}
                  />
                </IconButton>
              </DrawerHeader>
              <RouteForm
                mapAreaselection={mapAreaselection}
                handleRouteFormDollhousemapselection={
                  handleRouteFormDollhousemapselection
                }
              />
              <Divider />

              <List
                sx={{
                  width: "100%",
                  [_customTheme.breakpoints.down("md")]: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    width: "260px",
                    ...(show && {
                      opacity: 0,
                    }),
                  },
                  "& .MuiListItemText-root": {
                    color: "#FFFFFF",
                  },
                  "& span.MuiTypography-root": {
                    letterSpacing: 0,
                    font: "normal normal bold 12px/13px 'Trade Gothic LT Std', sans-serif",
                  },
                }}
              >
                {[
                  BELLAGIO,
                  ARIA,
                  VDARA,
                  THE_COSMOPOLITAN,
                  PARK_MGM,
                  NOMAD,
                  DOLBY,
                  TMOBILE,
                  DISTRICT_HIGHLIGHTS,
                ].map((text, index) => (
                  <ListItem
                    key={text}
                    disablePadding
                    sx={{ padding: 1 }}
                    id={text}
                  >
                    <IconButton
                      type="button"
                      className="turnright-svg"
                      sx={{
                        background: "transparent",
                        // border: "2px solid #BDA770",
                        borderRadius: "5px",
                        padding: 0,
                        paddingLeft: "20px",
                        "&:hover": { color: "#BDA770" },
                      }}
                      aria-label="search"
                      onClick={() => {
                        if (text === DISTRICT_HIGHLIGHTS) {
                          return;
                        }
                        handleAriaRouteSelection(text);
                      }}
                    >
                      {text === DISTRICT_HIGHLIGHTS ? (
                        <SvgTurnRightDisabled
                          sx={{ color: "#000000", width: "0.6em" }}
                        />
                      ) : (
                        <SvgTurnRight
                          sx={{ color: "#ffffff", width: "0.6em" }}
                        />
                      )}
                    </IconButton>

                    <ListItemButton
                      sx={{
                        paddingLeft: "10px",
                        paddingTop: "0px",
                        paddingBottom: "10px",
                        paddingRight: "8px",
                        "&:hover": {
                          cursor: "default",
                        },
                      }}
                    >
                      <ListItemText
                        primary={text}
                        sx={{
                          color:
                            text === highlightText
                              ? "#b59442 !important"
                              : "#ffffff",
                          "&:hover": {
                            color: "#b59442",
                            cursor: "pointer",
                          },
                        }}
                        onClick={() => {
                          sidemenuListNameClickEvent(text);
                        }}
                        id={text + "_names"}
                      />

                      {text === TMOBILE || text === DOLBY ? (
                        ""
                      ) : text === iconSwitch ? (
                        <IconButton
                          aria-label="arrow"
                          sx={{ padding: 0 }}
                          onClick={(e) => {
                            drawListToggle(text, e);
                          }}
                        >
                          <ChevronLeftIcon
                            sx={{
                              color: "#b59442",
                              background: "transparent",
                              "&:hover": {
                                color: "#b59442",
                              },
                            }}
                          />
                        </IconButton>
                      ) : (
                        <IconButton
                          sx={{ padding: 0 }}
                          aria-label="arrow"
                          onClick={(e) => {
                            drawListToggle(text, e);
                            store.index = false;
                            setDollHouseIndex(true);
                          }}
                        >
                          <ChevronRightIcon
                            sx={{
                              color: "#FFFFFF",
                              background: "transparent",
                              "&:hover": {
                                color: "#b59442",
                              },
                            }}
                          />
                        </IconButton>
                      )}
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Drawer>
          </Box>
        )}

        <Main
          id="mainContent"
          open={open}
          sx={{
            background: "rgb(211, 211, 211)",
            // [_customTheme.breakpoints.down("md")]: {
            //   marginLeft: 0,
            // },
          }}
        >
          <>
            <Stack spacing={2}>
              <Slide
                direction="right"
                in={show}
                mountOnEnter
                unmountOnExit
                id="sidebar-list-div"
              >
                <PopUpItem
                // sx={{
                //   overflow: "auto",
                // }}
                // sx={{
                //   top:
                //     _mouseY > 0 && _mouseY < 500
                //       ? `${_mouseY - 90}px`
                //       : _mouseY > 501 && _mouseY < 510
                //       ? `${_mouseY - 220}px`
                //       : _mouseY > 509 && _mouseY < 520
                //       ? `${_mouseY - 230}px`
                //       : _mouseY > 549 && _mouseY < 560
                //       ? `${_mouseY - 230}px`
                //       : _mouseY > 561 && _mouseY < 650
                //       ? `${_mouseY - 150}px`
                //       : _mouseY > 720 - 200
                //       ? `${_mouseY - 130}px`
                //       : `${_mouseY}px`,
                // }}
                >
                  <IconButton
                    onClick={() => {
                      setShow(false);
                      setIconvSwitch("");
                    }}
                    sx={{
                      width: "auto",
                      fontSize: "13px",
                      border: "none",
                      position: "initial",
                      display: "flex",
                      background: "transparent",
                      color: "#bda770",
                      height: "35px",
                      width: "35px",
                      top: "8px",
                      display: "none",
                      [_customTheme.breakpoints.down("md")]: {
                        display: "flex",
                      },
                      justifyContent: "flex-start",
                    }}
                  >
                    <KeyboardBackspaceIcon
                      sx={{
                        color: "##FFFFFF",
                      }}
                    />
                    Back
                  </IconButton>
                  <SidebarSlideMenu
                    value={sidebarname}
                    position={_mouseY}
                  ></SidebarSlideMenu>
                </PopUpItem>
              </Slide>
            </Stack>
          </>
          {Showexit && (
            <>
              <Stack spacing={0.5}>
                <ExitItem sx={{ marginTop: 20 }}>
                  <List
                    sx={{
                      "& .MuiListItemText-root": { color: "#BDA770" },
                      padding: 0,
                      "&:hover": { color: "#BDA770" },
                      "& span.MuiTypography-root": {
                        fontSize: 15,
                        fontFamily: "'Trade Gothic LT Std',sans-serif",
                        fontWeight: "bold",
                      },
                    }}
                  >
                    {["EXIT"].map((text, index) => (
                      <ListItem
                        key={text}
                        disablePadding
                        onClick={() => {
                          exitApplicaitonMap();
                        }}
                        sx={{
                          [_customTheme.breakpoints.down("md")]: {
                            height: "100%",
                          },
                        }}
                      >
                        <IconButton
                          type="button"
                          sx={{
                            padding: "8px",
                            paddingLeft: "30px",
                            color: "#BDA770",
                            "&:hover": { color: "#FFFFFF" },
                            [_customTheme.breakpoints.down("md")]: {
                              padding: 0,
                            },
                          }}
                          aria-label="search"
                        >
                          <ExitToAppIcon />
                        </IconButton>

                        <ListItemButton
                          sx={{
                            paddingLeft: "0",
                            paddingTop: "10px",
                            [_customTheme.breakpoints.down("md")]: {
                              padding: 0,
                            },
                          }}
                        >
                          <ListItemText
                            primary={text}
                            color="#BDA770"
                            sx={{
                              "&:hover": { color: "#BDA770" },
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </ExitItem>
                <InfoTabComponent value={marginMain}></InfoTabComponent>
                {/* {isDesktop && */}
                <ZoomButtonComponent></ZoomButtonComponent>
                {/* } */}
              </Stack>
            </>
          )}
          {/* {isDesktop && */}
          <Viewer3D
            exploreBtn={exploreBuildingView}
            renderViewType={renderViewType}
            currentAreaSelected={mapAreaselection}
            mapRenderDatas={mapRenderDatas}
            levelMapReset={levelMapReset}
            dollhouseImages={dollhouseImages}
            sidebarStatus={marginMain}
          ></Viewer3D>
          {/* } */}

          {/* {isMobile &&
            <>
              <Scene3D index={dollHouseIndex} />
              <IsometricOverlay exploreBtn={exploreBuildingView}
                index={dollHouseIndex}></IsometricOverlay>
              {barOpen && (
                <>
                  <ZoomButtonComponent index={dollHouseIndex}></ZoomButtonComponent>
                  <Box sx={{
                    position: 'absolute',
                    top: 0,
                    width: `calc(100% - ${marginMain}px)`,
                    zIndex: dollHouseIndex ? 2 : -1
                  }}>
                    <DollhouseView
                      renderViewType={renderViewType}
                      currentAreaSelected={mapAreaselection}
                      mapRenderDatas={mapRenderDatas}
                      levelMapReset={levelMapReset}
                      dollhouseImages={dollhouseImages}
                    />
                  </Box>
                </>
              )}
            </>
          } */}
        </Main>
        <Snackbar
          open={snackopen}
          autoHideDuration={2000}
          onClose={__snackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            elevation={6}
            severity="warning"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {sanckMessage}
          </MuiAlert>
        </Snackbar>
        <ConfirmationMessage
          open={confirmationVisibile}
          removeConfirmationMessage={removeConfirmationMessage}
          disagreeConfirmation={disagreeConfirmation}
          agreeConfirmation={agreeConfirmation}
        />
      </Box>
    </>
  );
};

function LeftBar() {
  const [isLogined, setUserLogined] = React.useState(false);

  const updateLoginStatus = (status) => {
    setUserLogined(status);
  };

  return (
    <>
      {isLogined ? (
        <PersistentDrawerLeft />
      ) : (
        <Login updateLoginStatus={updateLoginStatus} />
      )}
    </>
  );
}

export {
  LeftBar,
  leftBarVisibility,
  exitVisibility,
  _IntoTabClick,
  switchdollhouse,
  __mobileHideBar,
};
